// extracted by mini-css-extract-plugin
export var tooltip = "truncated-text-module--tooltip--8b0b5";